import React, { memo } from "react"
import { DiscreteNode as DiscreteNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const DiscreteNode = memo((node: DiscreteNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-discrete">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

DiscreteNode.displayName = "DiscreteNode"
